// Transform block tree state condition to block server condition
const BlockActionConditionTranformer = (origin) => {

    const data = { ...origin };
    
    return data
}

export default BlockActionConditionTranformer;